import { Instagram } from 'lucide-react'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="border-t border-[var(--line)] px-6 pb-10 pt-14 md:px-10" data-testid="footer">
      <div className="mx-auto flex max-w-6xl flex-col gap-10">
        <div className="flex flex-col justify-between gap-8 md:flex-row md:items-end">
          <div>
            <img src="/logo-nmb.webp" alt="No More Bluff" className="w-44" data-testid="footer-logo" draggable={false} />
            <p className="eyebrow mt-4 !normal-case !tracking-[0.08em] !text-haze" data-testid="footer-tagline">
              Built to keep you going.
            </p>
          </div>
          <div className="flex items-center gap-6">
            <a
              href="https://instagram.com/nomorebluff"
              target="_blank"
              rel="noreferrer"
              aria-label="No More Bluff on Instagram"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[var(--line)] text-ink transition-all duration-500 hover:bg-ink hover:text-paper"
              data-testid="footer-instagram-link"
            >
              <Instagram size={16} />
            </a>
          </div>
        </div>
        <div className="flex flex-col gap-2 border-t border-[var(--line)] pt-6 text-[0.75rem] text-haze sm:flex-row sm:justify-between" data-testid="footer-copyright">
          <span>© {year} No More Bluff. All rights reserved.</span>
          <span>Coming soon, slowly.</span>
        </div>
      </div>
    </footer>
  )
}
